/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/destructuring-assignment */
import { Component } from 'react';
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
        };
    }
    static getDerivedStateFromError(_) {
        return {
            hasError: true,
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error('Error:', error);
        console.error('Error Info:', errorInfo);
    }
    render() {
        if (this.state.hasError) {
            document.body.style.overflow = 'visible';
            return;
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
